import { useQuery } from 'react-query';

import dpiaRequestsApi from 'config/api/dpiaRequests/dpiaRequests';
import QUERY_KEYS from 'config/api/QUERY_KEYS';

import { catchHttpStatuses, HTTP_UNAVAILABLE_STATUSES, isUnavailableQueryResult, unwrapAvailableQueryData } from './queryUnavailable';

type Params = {
  apaId?: number;
  enabled?: boolean;
  organizationId?: number;
};

const useDpiaHistory = ({ apaId, enabled = true, organizationId }: Params) => {
  const query = useQuery(
    [QUERY_KEYS.DPIA_HISTORY, organizationId, apaId],
    async () =>
      catchHttpStatuses(async () => {
        const { data } = await dpiaRequestsApi.getDpiaHistory(organizationId as number, apaId as number);
        return data;
      }, HTTP_UNAVAILABLE_STATUSES),
    {
      enabled: Boolean(enabled && organizationId && apaId),
      retry: false,
    },
  );

  return {
    ...query,
    history: unwrapAvailableQueryData(query.data),
    isUnavailable: isUnavailableQueryResult(query.data),
  };
};

export default useDpiaHistory;
